import { ApiQueries, DaymapIcon, DaymapIconType, DiaryItem, NoItems, useApp, useAppState, useStudent, DaymapSkeleton } from "daymap-react";
import { useLocation, useParams } from "react-router-dom";
import { PageContainer, PageDescriptor } from "../../../components/layout";
import { Alert, Box, FormControl, InputLabel, MenuItem, Select, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDiaryItemClick } from "../../../components/diary";

const now = new Date();

type ScheduleForm = {
    dateFrom: Date;
    calendar: string;
}

export function Schedule() {
    const {studentId} = useParams();
    const location = useLocation();
    const { setScrollPosition, restoreScrollPosition } = useApp();
    const student = useStudent(Number(studentId));
    const [ state, setViewState ] = useAppState<ScheduleForm>("ScheduleForm", { dateFrom: now, calendar: "" }, "session");
    const { isPending, data, error } = new ApiQueries.calendars.DiaryItems({ nonTimetableOnly: true, studentId: Number(studentId), from: state.dateFrom, to: new Date(now.getFullYear(), 11, 31) }).ToQuery();
    const { handleItemClick, modalElement } = useDiaryItemClick({ 
        onNavigate: () => setScrollPosition(location.key) 
    });
    
    useEffect(() => {
        restoreScrollPosition(location.key);
    }, [])

    const { calendar } = state;

    if (isPending)
        return <DaymapSkeleton type="page"/>

    return <PageContainer>
        <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.CalendarMonth} />} title="Schedule">
            View {student?.Displayname}'s event schedule for the current year
        </PageDescriptor>
        { error && <Alert severity="error">
                {error.title}
            </Alert>}
        {data && data.length > 0 && <Box pt={2}>
            <FormControl sx={{ minWidth: 150 }}>
                <InputLabel id="calendar-label">Calendar</InputLabel>
                <Select
                    labelId="calendar-label"
                    id="calendar"
                    value={calendar}
                    label="Calendar"
                    onChange={e => setViewState({ ...state, calendar: e.target.value })}
                >
                    <MenuItem value="">All</MenuItem>
                    {data.filter((d, i, a) => i === a.findIndex(dd => d.Calendar === dd.Calendar)).map(d => <MenuItem key={d.ID} value={d.Calendar}>{d.Calendar}</MenuItem>)}
                </Select>
            </FormControl>
        </Box>}
        <Stack spacing={1} pt={3}>
            {modalElement}
            {((!isPending && !data) || data.length === 0) && <NoItems>No events scheduled</NoItems>}
            {data?.filter(d => calendar === "" || d.Calendar === calendar).map(d => <DiaryItem key={`${d.Type} ${d.ID}`} {...d} hideStudentChip onClick={handleItemClick} />)}
        </Stack>
    </PageContainer>
}
